import type { UserRole } from '../stores/authStore';

export type ReviewMode = 'admin' | 'finance' | 'hr';

/**
 * Adds the Finance Lead restriction for finance mode only (the API enforces the
 * same). Admin and HR modes return true regardless of role and rely on route
 * guards for access control.
 */
export function canFinalizeReview(mode: ReviewMode, role: UserRole | undefined): boolean {
  if (mode === 'finance') return role === 'FINANCE_LEAD';
  return true;
}
